import { render, staticRenderFns } from "./CourseCohortViewStudentsSectionList.vue?vue&type=template&id=1c9da930&"
import script from "./CourseCohortViewStudentsSectionList.vue?vue&type=script&lang=js&"
export * from "./CourseCohortViewStudentsSectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports